import http from "../utils/http-common";

const getById = (id: number) => {
  return http.get(`/resource/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/resource/${id}`, data);
};
const remove = (id: number) => {
  return http.delete(`/resource/${id}`);
};
const post = (data: any) => {
  return http.post(`/resource`, data);
};

const getAll = () => {
  return http.get(`/resource`);
};

const getByAgentId = (id: number) => {
  return http.get(`/resource/agent/${id}`);
};

const resourceService = {
  getById,
  put,
  remove,
  post,
  getAll,
  getByAgentId,
};
export default resourceService;
